import { Component, OnInit, NgModule, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { DxTabsModule } from 'devextreme-angular/ui/tabs';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { DxTabsTypes } from 'devextreme-angular/ui/tabs';
import { DxTextBoxTypes } from 'devextreme-angular/ui/text-box';
import { taskPanelItems } from 'src/app/types/resource';
import { WorkRequest, WorkRequestRole } from 'src/app/types/work-request';
import { Task, newTask } from 'src/app/types/task';
import { DataService, ScreenService } from 'src/app/services';
import { forkJoin, map, Observable, Subscription } from 'rxjs';
import { TaskFormComponent, TaskFormModule } from 'src/app/components/library/task-form/task-form.component';
import { FormPopupModule } from 'src/app/components/utils/form-popup/form-popup.component';
import { WorkRequestListGridComponent, WorkRequestListGridModule } from 'src/app/components/library/work-request-list-grid/work-request-list-grid.component';
import { TaskListKanbanModule, TaskListKanbanComponent } from 'src/app/components/library/task-list-kanban/task-list-kanban.component';
import { TaskListGanttComponent, TaskListGanttModule } from 'src/app/components/library/task-list-gantt/task-list-gantt.component';
import { DxLoadPanelModule } from 'devextreme-angular/ui/load-panel';
import { NavigationEnd, Router } from '@angular/router';

@Component({
	templateUrl: './work-request-list.component.html',
	styleUrls: ['./work-request-list.component.scss'],
})
export class WorkRequestListComponent implements OnInit {
	private _dataService: DataService;
	private _screenService: ScreenService;
	private _router: Router;
	private _routerSubscription: Subscription | null = null;

	public get ScreenService(): ScreenService {
		return this._screenService;
	}

	@ViewChild('planningDataGrid', { static: false }) dataGrid: WorkRequestListGridComponent;

	@ViewChild('planningKanban', { static: false }) kanban: TaskListKanbanComponent;

	@ViewChild(TaskFormComponent, { static: false }) taskForm: TaskFormComponent;

	taskPanelItems = taskPanelItems;

	displayTaskComponent = this.taskPanelItems[0].text;

	displayGrid = this.displayTaskComponent === this.taskPanelItems[0].text;

	displayKanban = this.displayTaskComponent === this.taskPanelItems[1].text;

	workRequests: WorkRequest[];

	constructor(
		dataService: DataService, 
		screenService: ScreenService, 
		router: Router
	) {
		this._dataService = dataService;
		this._screenService = screenService;
		this._router = router;

		this._dataService.getTenantId().subscribe((data) => {
			this.handleRefresh();
		});
	}

	private loadData() {
		this._dataService.getWorkRequests()
			.subscribe({
				next: (response: any) => { 
					this.workRequests = response.data.filter(r => r.tenantId === this._dataService.tenantId && r.role !== WorkRequestRole.NoRight);
				}
			});	
	}

	ngOnInit(): void {
		this.loadData();
	}

	tabValueChange(e: DxTabsTypes.ItemClickEvent) {
		const { itemData } = e;

		this.displayTaskComponent = itemData.text;
		this.displayGrid = this.displayTaskComponent === this.taskPanelItems[0].text;
		this.displayKanban = this.displayTaskComponent === this.taskPanelItems[1].text;
	};

	public handleAddWorkRequest = () => {
		this._router.navigate([`/work-request-details/-1`]);
	};

	public handleRefresh = () => {
		this.loadData();
		if (this.displayGrid) {
			this.dataGrid.refresh();
		} else if (this.displayKanban) {
			this.kanban.refresh();
		}
	};

	public chooseColumnDataGrid = () => this.dataGrid.showColumnChooser();

	searchDataGrid = (e: DxTextBoxTypes.InputEvent) => this.dataGrid.search(e.component.option('text'));

	public exportToPdf = () => {
		if (this.displayGrid) {
			this.dataGrid.onExportingToPdf();
		}
	};

	public exportToXslx = () => this.dataGrid.onExportingToXLSX();
}

@NgModule({
	imports: [
		DxButtonModule,
		DxDataGridModule,
		DxTabsModule,
		DxToolbarModule,
		DxLoadPanelModule,
		FormPopupModule,

		TaskFormModule,
		TaskListKanbanModule,
		WorkRequestListGridModule,
		TaskListGanttModule,

		CommonModule,
	],
	providers: [],
	exports: [],
	declarations: [WorkRequestListComponent],
})
export class WorkRequestListModule { }
